const navList = [
    {
        id:1,
        name: 'Profile',
        icon: 'bi bi-person',
    },
    {
        id:2,
        name: 'Contact',
        icon: 'bi bi-envelope',
    },
    {
        id:3,
        name: 'Register',
        icon: 'bi bi-card-list',
    },
    {
        id:4,
        name: 'Login',
        icon: 'bi bi-box-arrow-in-right',
    },
    {
        id:5,
        name: 'Setting',
        icon: 'bi bi-gear',
    },
    {
        id:6,
        name: 'F.A.Q',
        icon: 'bi bi-question-circle',
    },
    {
        id:7,
        name: 'Blank',
        icon: 'bi bi-file-earmark',
    },
]

export default navList;